// AI-CONTEXT: See docs/patterns.md#hook-permission-gate

/** De elementen waarmee je iets aanpast; een druk daarop is een poging tot bewerken. */
const CONTROL_SELECTOR = 'button, input, select, textarea'

/**
 * Het uitgeschakelde veld of de knop die een druk binnen `root` bedoelde.
 *
 * Nodig omdat ReadOnlyGuard niet op `click` kan luisteren: een uitgeschakeld
 * veld krijgt geen klik, en hij borrelt ook niet naar boven (in Chrome
 * nagemeten). `pointerdown`/`pointerup` komen wél aan, met het veld zelf als
 * doel — dus hier is geen plaatsbepaling nodig, alleen de vraag welk veld dat
 * doel is of bevat: het icoon in een knop, of het label dat een eigen vinkje
 * tekent.
 *
 * @param {Element} root - Het blok waarbinnen gezocht wordt
 * @param {EventTarget | null} target - Het doel van de pointer-event
 * @returns {Element | null} Het uitgeschakelde veld, of null
 */
const deniedControl = (root, target) => {
    if (!(target instanceof Element) || !root.contains(target)) return null

    const label = target.closest('label')
    const control = target.closest(CONTROL_SELECTOR)
        || (label && /** @type {HTMLLabelElement} */ (label).control)

    if (!control || !root.contains(control)) return null
    // Alleen wat écht uit staat; de eerste legend van een fieldset doet gewoon mee.
    return control.matches(':disabled') ? control : null
}

export default deniedControl
